<script setup>
import { ref } from 'vue';
import TransactionPanel from '@maison/components/organisms/transactionPanel/TransactionPanel.vue';
import { PhxClusterSlider, PhxIcon } from '@phx-styleguides/iwc';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const activeSlideIndex = ref(0);

function onSlideChange(index) {
  activeSlideIndex.value = index;
}

function scrollDown() {
  window.scrollBy(0, window.innerHeight);
}
</script>

<template>
  <phx-cluster-slider :id="id" :slides="slides" :label="label" @slide-change="onSlideChange" />

  <div
    class="center grid__items grid-layout grid--spacing-3 center--spacing-3 center--sizing-3xl cluster-slider__content-grid"
  >
    <div
      v-for="(slide, index) in slides"
      :key="`${id}-content-${index}`"
      :class="['cluster-slider__content', { 'is-active': index === activeSlideIndex }]"
      :aria-hidden="index !== activeSlideIndex"
      :inert="index !== activeSlideIndex"
    >
      <p class="flex justify-between title-caption">
        <span>{{ $t('ClusterSlider.sizes') }}</span>
        <span>{{ slide.sizes }}</span>
      </p>

      <hr class="divider divider--spacing-2" />

      <p class="mt-2">{{ slide.description }}</p>

      <a :href="slide.data.content.action.href" type="button" class="btn mt-4 md:hidden btn--link">
        <span class="btn__text">{{ slide.data.content.action.label }}</span>
      </a>
    </div>

    <transition name="cluster-slider__transaction-panel">
      <div v-if="slides[activeSlideIndex]">
        <transaction-panel v-bind="slides[activeSlideIndex].panel" />
      </div>
    </transition>
  </div>

  <div class="scroll-incentive cluster-slider__scroll-incentive max-sm:hidden" aria-hidden="true">
    <div class="scroll-incentive__arrow">
      <button
        type="button"
        class="btn btn--icon btn--icon-only btn--icon-only btn--primary btn--fade"
        @click="scrollDown()"
      >
        <span class="btn__icon btn__icon--end">
          <phx-icon icon="chevron-down" class="icon--2xl" :title="$t('ClusterSlider.scrollToNextSection')" />
        </span>
      </button>
    </div>
  </div>
</template>
